// extracted by mini-css-extract-plugin
export default {"content":"nN18RBf","opacityIn":"zvOHOMT","type":"uLhGPx1","msg":"wg6acpC","error":"yu0rAQi","close":"VM80nvZ","fullHeight":"oyuqVGQ","opacityOut":"xe1FHBM"};